import { ErrorReportContext } from "../../services";

// #region detectBrowser
// Coarse UA sniff — good enough to answer "which browser was this?" in triage.
// Order matters: Edge/Opera also contain "Chrome", Chrome also contains "Safari".
const detectBrowser = (userAgent: string): string => {
    if (/Edg\//.test(userAgent)) return 'Edge';
    if (/OPR\//.test(userAgent) || /Opera/.test(userAgent)) return 'Opera';
    if (/Firefox\//.test(userAgent)) return 'Firefox';
    if (/Chrome\//.test(userAgent)) return 'Chrome';
    if (/Safari\//.test(userAgent)) return 'Safari';
    return 'Unknown';
};

// #region detectOs
const detectOs = (userAgent: string): string => {
    if (/Windows NT 10/.test(userAgent)) return 'Windows 10/11';
    if (/Windows/.test(userAgent)) return 'Windows';
    if (/iPhone|iPad|iPod/.test(userAgent)) return 'iOS';
    if (/Mac OS X/.test(userAgent)) return 'macOS';
    if (/Android/.test(userAgent)) return 'Android';
    if (/Linux/.test(userAgent)) return 'Linux';
    return 'Unknown';
};

// #region captureContext
// Everything the dev needs to reproduce, gathered without asking the user.
// Guarded so a non-browser render (tests/SSR) can't throw.
export const captureContext = (): ErrorReportContext => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return {};

    const userAgent = navigator.userAgent || '';
    return {
        page_url: window.location.href,
        user_agent: userAgent,
        browser: detectBrowser(userAgent),
        os: detectOs(userAgent),
        viewport_width: window.innerWidth,
        viewport_height: window.innerHeight,
        app_version: process.env.REACT_APP_VERSION || null,
    };
};
